import { getIn } from "formik";

/**
 * The function returns a CSS class name based on the validation status of a form input field using
 * Formik library.
 * @param formik - An object containing the formik state and helper functions for a form.
 * @param name - The name of the input field for which the border class is being generated.
 * @returns a string representing the CSS class name for the input field border based on the state of
 * the formik form and the input field's name. The returned class name will be one of the following:
 * "errorStyle form-control bg-white", "successField form-control bg-white", or "form-control
 * bg-white".
 */
export default function getInputFieldBorderClassName(formik, name) {
  // console.log(`getInputFieldBorderClassName ${name}`);
  const errorClasses = "errorStyle form-control bg-white";
  const successValidatedClasses = "successField form-control bg-white";
  const normalLookClass = "form-control bg-white";

  if (!formik || !formik.touched || !formik.errors) {
    return normalLookClass;
  } else if (getIn(formik.touched, name) && getIn(formik.errors, name)) {
    return errorClasses;
  } else if (getIn(formik.touched, name) && !getIn(formik.errors, name)) {
    return successValidatedClasses;
  }
  return normalLookClass;
}
